<template>
  <v-dialog v-model="dialog" max-width="500" persistent scrollable>
    <v-form ref="form">
        <v-card tile>
          <v-card-title>
            <v-col cols="11" style="text-align: center; padding-left: 9%;">
              <span
                class="text-333333 font-20 w-700"
                style="align-self: center;"
                >นัดหมายเยี่ยมบ้าน</span
              ></v-col
            >
            <v-spacer></v-spacer>
            <v-btn icon color="#00A99D" @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-col cols="12"><v-divider></v-divider></v-col>
          </v-card-title>
      <v-card-text class="pt-8 px-8" ref="dialogContent">
          <v-row class="px-3">
            <span class="text-00A99D font-16 w-600">วัน - เวลานัดหมาย</span>
            <v-spacer></v-spacer>
            <span class="text-00A99D font-16 w-600">ครั้งที่ {{ detail.appointment_no || '0' }}</span>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">วันที่ทำการนัดหมาย</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="DateFormatted"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    color="#00A99D"
                    solo
                    dense
                    hide-details="auto"
                    placeholder="ระบุ วัน/เดือน/ปี ที่ทำการนัดหมาย"
                    required
                    rounded
                    :rules="rules"
                  >
                    <template v-slot:append>
                      <v-icon color="#00A99D">mdi-calendar</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.slot_date"
                  no-title
                  :allowed-dates="disablePastDates"
                  @input="menu = false"
                  color="#00A99D"
                  locale="th"
                  @change="setTime()"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">เวลาที่เริ่มต้นนัดหมาย</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                solo
                hide-details="auto"
                dense
                v-model="detail.startTime"
                :items="time"
                color="#00A99D"
                item-color="teal"
                rounded
                placeholder="ระบุเวลาที่เริ่มต้นนัดหมาย"
                :rules="rules"
                @change="setTime2()"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">เวลาที่สิ้นสุดนัดหมาย</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                solo
                hide-details="auto"
                dense
                v-model="detail.endTime"
                :items="time2"
                color="#00A99D"
                item-color="teal"
                rounded
                placeholder="ระบุเวลาที่สิ้นสุดนัดหมาย"
                :rules="rules"
              >
                <template slot="no-data">
                  <span class="pl-2">กรุณาเลือกเวลาที่เริ่มต้นนัดหมายก่อน</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">ทีมแพทย์</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                solo
                hide-details="auto"
                dense
                v-model="detail.doctor"
                :items="doctor"
                item-text="title"
                item-value="detail"
                color="#00A99D"
                item-color="teal"
                rounded
                placeholder="ระบุชื่อแพทย์"
                :rules="rules"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">กลุ่มเป้าหมาย</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                solo
                hide-details="auto"
                dense
                v-model="detail.target_group"
                :items="target"
                color="#00A99D"
                item-color="teal"
                rounded
                placeholder="ระบุกลุ่มเป้าหมาย"
                :rules="rules"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">ความเร่งด่วน</span>
              <span class="text-red font-16 w-500"> *</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-autocomplete
                solo
                hide-details="auto"
                dense
                v-model="detail.urgency"
                :items="urgency"
                item-text="title"
                item-value="value"
                color="#00A99D"
                item-color="teal"
                rounded
                placeholder="ระบุความเร่งด่วน"
                :rules="rules"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <span class="text-333333 font-16 w-500">เหตุผลในการนัดหมาย</span>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-textarea
                solo
                hide-details="auto"
                dense
                v-model="detail.note"
                color="#00A99D"
                item-color="teal"
                rows="3"
                placeholder="ระบุเหตุผลในการนัดหมาย"
              ></v-textarea>
            </v-col>
          </v-row>
      </v-card-text>
      <v-card-actions class="pb-5 pt-0 px-10">
        <v-col cols="6" class="pr-2 pl-0">
          <v-btn 
            block
            outlined 
            rounded 
            color="#00a99d" 
            @click="closeDialog()"
            style="border-radius: 20px 5px;"
          >
            ยกเลิก
          </v-btn>
        </v-col>
        <v-col cols="6" class="pl-2 pr-0">
          <v-btn
            rounded
            block
            dark
            depressed
            color="#00a99d"
            :loading="btn_loading"
            type="submit"
            @click.prevent="saveDate()"
            style="border-radius: 20px 5px;"
          >
            ตกลง
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
    <Sweetdialog ref="sweetDialog" />
  </v-form>
  </v-dialog>
</template>

<script>
import moment from "moment";
import Sweetdialog from "../Telepharma/Sweetdialog.vue";

export default {
  components: {
    Sweetdialog,
  },
  data() {
    return {
      dialog: false,
      btn_loading: false,
      menu: false,
      minDate: '',
      time: [],
      time2: [],
      doctor: [],
      target: [],
      urgency: [],
      detail: {
        appointment_no: '1',
        slot_date: '',
        startTime: '',
        endTime: '',
        doctor: '',
        target_group: '',
        urgency: '',
        note: ''
      },
      rules: [(v) => !!v || "กรุณาระบุข้อมูล"],
    }
  },
  computed: {
    x_mobile() {
      if (this.$vuetify.breakpoint.width < 960) {
        return true;
      } else {
        return false;
      }
    },
    DateFormatted () {
      return this.formatDate(this.detail.slot_date)
    },
  },
  methods: {
    setTime() {
      if (this.detail.startTime) {
        this.detail.startTime = '';
        this.detail.endTime = '';
      }
      // this.time = []
      // console.log('startTime', startTime);
      // console.log('moment', moment().format("YYYY-MM-DD HH"));
      // var m = moment().format("YYYY-MM-DD")
      // var h = parseInt(moment().format("HH"))
      // var n = parseInt(moment().format("mm"))
      // // console.log(n);
      // // console.log(parseInt(n)-60);
      // // console.log(h);
      // // console.log(parseInt(h)+1);
      // if (startTime == m && h>= 7 && n<=30) {
      //   console.log(111);
      //   for(var i=h+1; i<=17; i++) {
      //     if(i < 10) {
      //       this.time.push('0'+i+':00')
      //       this.time.push('0'+i+':30')
      //     } else {
      //       this.time.push(i+':00')
      //       if(i < 17) {
      //         this.time.push(i+':30')
      //       }
      //     }
      //   }
      // }else if(startTime == m && h>= 7 && n>30) {
      //   console.log(222);
      //   for(var j=h+1; j<=17; j++) {
      //     if(j < 10) {
      //       this.time.push('0'+j+':00')
      //       this.time.push('0'+j+':30')
      //     } else {
      //       this.time.push(j+':30')
      //       if(j < 17) {
      //         this.time.push(j+':30')
      //       }
      //     }
      //   }
      // }else {
      //   console.log(333);
      //   for(var k=7; k<=17; k++) {
      //     if(k < 10) {
      //       this.time.push('0'+k+':00')
      //       this.time.push('0'+k+':30')
      //     } else {
      //       this.time.push(k+':00')
      //       if(k < 17) {
      //         this.time.push(k+':30')
      //       }
      //     }
      //   }
      // }
    },
    setTime2() {
      this.time2 = []
      var char = Object.assign([], this.detail.startTime);
      var h
      if(char[0] == '0') {
        h = parseInt(char[1])
        if(parseInt(char[3]+char[4]) == 30) {
          for(var h1=(h+1); h1<=17; h1++) {
          if(h1 < 10) {
            this.time2.push('0'+h1+':00')
            this.time2.push('0'+h1+':30')
          } else {
            this.time2.push(h1+':00')
            this.time2.push(h1+':30')
          }
        }
        } else {
          this.time2.push('0'+h+':30')
          for(var h2=(h+1); h2<=17; h2++) {
            if(h2 < 10) {
              this.time2.push('0'+h2+':00')
              this.time2.push('0'+h2+':30')
            } else {
              this.time2.push(h2+':00')
              this.time2.push(h2+':30')
            }
          }
        }
      } else {
        h = parseInt(char[0]+char[1])
        if(parseInt(char[3]+char[4]) == 30) {
          // console.log('h3', h3);
          for(var h3=(h+1); h3<=17; h3++) {
            this.time2.push(h3+':00')
            this.time2.push(h3+':30')
          }
        } else {
          this.time2.push(h+':30')
          for(var h4=(h+1); h4<=17; h4++) {
            this.time2.push(h4+':00')
            this.time2.push(h4+':30')
          }
        }
      }
    },
    openDialog(item, status) {
      // console.log('item',item);
      this.minDate = moment().format("YYYY-MM-DD");
      this.item = item
      this.action_type = status
      this.getCount()
      this.getDoctor()

      for(var i=7; i<=17; i++) {
        if(i < 10) {
          this.time.push('0'+i+':00')
          this.time.push('0'+i+':30')
        } else {
          this.time.push(i+':00')
          if(i < 17) {
            this.time.push(i+':30')
          }
        }
      }
      this.target = [
        'โรคเรื้อรัง',
        'จิตเวชและสารเสพติด',
        'PalliativeCare',
        'LongTermCare',
        'IntermediateCare',
        'ผู้พิการ',
        'PP&P'
      ]
      this.urgency = [
        {
          title: 'เร่งด่วนปกติ',
          value: 1
        },
        {
          title: 'เร่งด่วนปานกลาง',
          value: 2
        },
        {
          title: 'เร่งด่วนมาก',
          value: 3
        },
      ],
      this.dialog = true
    },
    async getDoctor() {
      const params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id)

      try {
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/doctor_nurse?${params}`).then((res) => {
          // console.log(res);
          if(res.data.result == 'success') {
            for(var x in res.data.data) {
              if (res.data.data[x].role == "แพทย์"){
                this.doctor.push(
                  {
                    title: `คุณหมอ ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                    detail: {
                      name: `คุณหมอ ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                      one_id: res.data.data[x].one_id
                    }
                  }
                )
              }else{
                let title = "พยาบาล"
                if (res.data.data[x].gender == "ชาย"){
                  title = "บุรุษพยาบาล"
                }
                this.doctor.push(
                  {
                    title: `${title} ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                    detail: {
                      name: `${title} ${res.data.data[x].staff_first_name_th} ${res.data.data[x].staff_last_name_th}`,
                      one_id: res.data.data[x].one_id
                    }
                  }
                )
              }
            }
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async getCount() {
      const params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id)
      params.append("userqr_id", this.item.userqr_id || '')
      params.append("first_name_th", this.item.first_name_th || '')
      params.append("last_name_th", this.item.last_name_th || '')
      params.append("mobile", this.item.mobile || '')

      try {
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_count_user_appointment?${params}`,
          ).then((res) => {
            // console.log(res);
            if (res.data.result == 'success') {
              this.detail.appointment_no = res.data.data.count
            }
          })
        } catch(err) {
        console.log(err);
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      let y = parseInt(year) + 543
      return `${day}/${month}/${y.toString()}`
    },
    closeDialog() {
      this.time = []
      this.time2 = []
      this.doctor = []
      this.target = []
      this.urgency = []
      this.detail = {
        appointment_no: '1',
        slot_date: '',
        startTime: '',
        endTime: '',
        doctor: '',
        target_group: '',
        urgency: '',
        note: ''
      },
      this.$refs.form.reset()
      this.$refs.dialogContent.scrollTop = 0;
      this.dialog = false
    },
    saveDate() {
      if(!this.$refs.form.validate()) {
        this.$swal({
          icon: "warning",
          title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          showConfirmButton: false,
        })
      } else {
        this.$swal.fire({
          title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันนัดหมาย</span>",
          html: this.action_type == 'revert' ? "<span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'>คุณ"+ this.item.fullname + "<br /> วันที่ "+ moment(this.detail.slot_date).locale("th").format("DD MMMM YYYY") + "<br />เวลา " + this.detail.startTime + "-" + this.detail.endTime +" น. ใช่หรือไม่ ?</span>" :
          "<span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'>คุณ"+ this.item.first_name_th + " " + this.item.last_name_th + "<br /> วันที่ "+ moment(this.detail.slot_date).locale("th").format("DD MMMM YYYY") + "<br />เวลา " + this.detail.startTime + "-" + this.detail.endTime +" น. ใช่หรือไม่ ?</span>",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText:
            "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              // this.btn_loading = true;
              // var params = new URLSearchParams();
              // params.append('biz_id', sessionStorage.getItem('biz_id'))
              // params.append('doctor_id', this.detail.doctor.one_id)
              // params.append('slot_date', this.detail.slot_date)
              // params.append('start_time', this.detail.startTime)
              // params.append('end_time', this.detail.endTime)

              // await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/home_visit/check_slot_doctor?${params}`)
              // .then(async (response) => {
              //   if(response.data.code == 200 && response.data.result == 'success') {
                  var params2 = new URLSearchParams();
                  params2.append('biz_id', sessionStorage.getItem('biz_id'))
                  params2.append('account_id', sessionStorage.getItem('account_id'))

                  var body = {}
                  if (this.action_type == 'revert') {
                    body = {
                      appointment_no: this.detail.appointment_no,
                      one_id: this.item.one_id,
                      userqr_id: this.item.userqr_id,
                      HN: this.item.HN,
                      account_title_th: this.item.account_title_th,
                      first_name_th: this.item.first_name_th,
                      last_name_th: this.item.last_name_th,
                      fullname: this.item.fullname,
                      mobile: this.item.mobile,
                      action_type: this.action_type,
                      birth_date: this.item.birth_date,
                      cid: this.item.cid,
                      gender: this.item.gender,
                      slot_date: this.detail.slot_date,
                      startTime: this.detail.startTime,
                      endTime: this.detail.endTime,
                      doctor_name: this.detail.doctor.name,
                      doctor_id: this.detail.doctor.one_id,
                      target_group: this.detail.target_group,
                      urgency: this.detail.urgency,
                      note: this.detail.note
                    }
                  } else {
                    body = {
                      appointment_no: this.detail.appointment_no,
                      one_id: this.item.one_id,
                      userqr_id: this.item.userqr_id,
                      HN: this.item.HN,
                      account_title_th: this.item.account_title_th,
                      first_name_th: this.item.first_name_th,
                      last_name_th: this.item.last_name_th,
                      fullname: this.item.first_name_th + ' ' + this.item.last_name_th,
                      mobile: this.item.mobile,
                      action_type: this.action_type,
                      birth_date: this.item.birth_date,
                      cid: this.item.cid,
                      gender: this.item.gender,
                      slot_date: this.detail.slot_date,
                      startTime: this.detail.startTime,
                      endTime: this.detail.endTime,
                      doctor_name: this.detail.doctor.name,
                      doctor_id: this.detail.doctor.one_id,
                      target_group: this.detail.target_group,
                      urgency: this.detail.urgency,
                      note: this.detail.note
                    }
                  }

                  // console.log(body);

                  await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/create_appointment_home_visit?${params2}`, body,
                  ).then((res) => {
                    if(res.data.result == 'success') {
                      this.$swal({
                        icon: "success",
                        title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยืนยันการนัดหมายสำเร็จ</span>",
                        showConfirmButton: false,
                        timer: 2000
                      }).then(() => {
                        this.btn_loading = false;
                        this.closeDialog()
                        this.$emit("close");
                        this.$emit("status_type", this.action_type);
                      })
                    } else {
                      this.$swal({
                        icon: "error",
                        title:
                          "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span> <br />"+
                          "<span style='color: black;font-size: 16px;font-family: Sarabun, sans-serif;'>เนื่องจาก "+ res.data.data +"</span>",
                        showConfirmButton: false,
                      }).then(() => {
                        this.btn_loading = false;
                        this.closeDialog();
                        this.$emit("close");
                      });
                    }
                  })
              //   } else if(response.data.code == 200 && response.data.result == 'fail') {
              //     this.$swal({
              //       icon: "error",
              //       title:
              //         "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span> <br />"+
              //         "<span style='color: black;font-size: 16px;font-family: Sarabun, sans-serif;'>"+ response.data.message +"</span>",
              //       showConfirmButton: false,
              //     }).then(() => {
              //       this.btn_loading = false;
              //       this.closeDialog();
              //       this.$emit("close");
              //     });
              //   } else {
              //     this.$swal({
              //       icon: "error",
              //       title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
              //       showConfirmButton: false,
              //     }).then(() => {
              //       this.btn_loading = false;
              //       this.closeDialog();
              //       this.$emit("close");
              //     });
              //   }
              // })
            } catch (err) {
              this.btn_loading = false;
              console.log(err);
            }
          }
        })
      }
    },
    disablePastDates(val) {
       return val >= new Date().toISOString().substr(0, 10)
    },
  }
}
</script>

<style scoped>
.card-medium-cancel {
  border-radius: 20px 5px;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-shadow: none;
}
</style>